module.exports = __webpack_public_path__ + "static/media/logo_tpbank.f9a8c6cb.svg";